<template>
  <PropertyDetailsCardInfoItem
    v-if="petsAllowed"
    :label="petPolicy?.allowsPets ? 'Allowed pets' : 'Pets'"
    :value="petsAllowed"
  />

  <template v-if="petPolicy?.allowsPets">
    <PropertyDetailsCardInfoItem v-if="petPolicy?.maxPets" :label="'Max number of pets'" :value="petPolicy?.maxPets" />

    <PropertyDetailsCardInfoItem v-if="petPolicy?.petRent" :label="'Pet rent'" :value="`$${petPolicy?.petRent}`" />

    <PropertyDetailsCardInfoItem
      v-if="petPolicy?.petDeposit"
      :label="'Pet deposit'"
      :value="`$${petPolicy?.petDeposit}`"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { PetPolicy } from '../../model/pet-policy';
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();
const petPolicy = computed(() => props.property?.petPolicy);
const petsAllowed = computed(() => {
  if (!petPolicy.value) {
    return;
  }

  if (!petPolicy.value?.allowsPets) {
    return 'Not Allowed';
  }

  const policyLabels = [
    {
      policy: petPolicy.value?.smallDogsPolicy,
      label: 'Small dogs',
    },
    {
      policy: petPolicy.value?.largeDogsPolicy,
      label: 'Large dogs',
    },
    {
      policy: petPolicy.value?.catsPolicy,
      label: 'Cats',
    },
    {
      policy: petPolicy.value?.otherPetsPolicy,
      label: 'Other',
    },
  ];

  return policyLabels
    .filter((item) => item.policy === PetPolicy.Allowed)
    .map((item) => item.label)
    .join(', ');
});
</script>
